import { useState } from 'react';
import useNoThumbnail from '../../../theme/useNoThumbnail';

type Props = {
  src?: string | null;
  alt: string;
  className?: string;
  title?: string;
  fallbackSrc?: string;
};

function ImageWithFallback({
  src,
  alt,
  className,
  title,
  fallbackSrc,
}: Props): JSX.Element {
  const noThumbnail = useNoThumbnail();
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  const isFallback = !src || failedSrc === src;

  return (
    <img
      className={className}
      src={isFallback ? fallbackSrc ?? noThumbnail : src}
      alt={alt}
      title={isFallback ? title ?? 'Picture not available' : title}
      onError={() => {
        if (src) {
          setFailedSrc(src);
        }
      }}
    />
  );
}

export default ImageWithFallback;
